// 初始化pinia

import Vue from 'vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
// import piniaPersist from 'pinia-plugin-persist'

const pinia = createPinia()
// pinia.use(piniaPersist) // 暂时禁用数据存本地，web端暂时不需要
Vue.use(PiniaVuePlugin)

export default pinia

export * from 'pinia'
